'use client';

import LoadingError from '@/components/Error';

import { captureException } from '@sentry/nextjs';
import { useEffect } from 'react';

export default function Error({
  error,
  reset: _reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <div>
      <LoadingError
        title="Error loading homepage"
        description={error.message}
      />
    </div>
  );
}
